const searchParams = new URL(window.location.href).searchParams;
const hasAllowedParam =
    searchParams.has('kameleoonSelectionIframeMode') && searchParams.get('kameleoonSelectionIframeMode') === 'true';
if (!hasAllowedParam && self !== top) {
    top.location = self.location;
}
